import PropTypes from "prop-types";
import React from "react";
import styled from "styled-components";

const Row = ({ className, children, columnSpacing, alignItems, margin, wrap, responsive, onClick, justifyContent }) => {
  if (responsive) {
    className = className ? `${className} -responsive` : "-responsive";
  }
  return (
    <StyledRow
      className={className}
      columnSpacing={columnSpacing}
      alignItems={alignItems}
      margin={margin}
      wrap={wrap && "wrap"}
      onClick={onClick}
      justifyContent={justifyContent}
    >
      {children}
    </StyledRow>
  );
};

Row.propTypes = {
  className: PropTypes.string,
  children: PropTypes.any,
  columnSpacing: PropTypes.string,
  alignItems: PropTypes.string,
  wrap: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  responsive: PropTypes.bool,
  onClick: PropTypes.func,
  justifyContent: PropTypes.string,
};

export default Row;

const StyledRow = styled.div.attrs((props) => ({
  columnSpacing: props.columnSpacing || "16px",
  alignItems: props.alignItems || "flex-start",
  margin: props.margin,
  wrap: props.wrap || "nowrap",
  justifyContent: props.justifyContent || "center",
}))`
  display: flex;
  flex-direction: row;
  align-items: ${(props) => props.alignItems};
  margin: ${(props) => props.margin};
  flex-wrap: ${(props) => props.wrap};

  > .column,
  > * {
    min-width: 0;

    &:not(:last-child) {
      margin-right: ${(props) => props.columnSpacing};
    }
  }

  @media screen and (max-width: 834px) {
    justify-content: ${(props) => props.justifyContent};
    &.-responsive {
      flex-direction: column;

      > .column,
      > * {
        min-width: 0;
        min-height: 0;

        &:not(:last-child) {
          margin-right: 0;
          margin-bottom: ${(props) => props.columnSpacing};
        }
      }
    }
  }
`;
